import {
  useAuthStore,
  useErrorMessage,
  hostRole,
  goToHost,
  finishRoundTrip,
  RoundTripExpired,
} from '@sentinel/web-core';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { Button, ErrorState } from '@sentinel/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { homeOf } from '@/core/auth/enter-destination';
import { AuthCard } from '../AuthCard';

/** Back from `accounts.`: the code and the verifier of this tab make this app's own session. */
export function HostCallbackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const errorMessage = useErrorMessage();
  const applyGrant = useAuthStore((s) => s.applyGrant);
  const { code }: { code?: string } = useSearch({ strict: false });
  const [failure, setFailure] = useState<string | null>(null);

  useEffect(() => {
    finishRoundTrip(code)
      .then((grant) => {
        applyGrant(grant);
        void navigate({ to: homeOf(grant.me), replace: true });
      })
      .catch((error: unknown) =>
        setFailure(
          error instanceof RoundTripExpired ? t('accounts.hosts.expired') : errorMessage(error),
        ),
      );
  }, [code]);

  const retry = () => {
    const role = hostRole();
    if (role === 'console' || role === 'control') goToHost(role);
  };

  return (
    <AuthCard title={t('accounts.hosts.arriving')} purpose="handoff">
      {failure === null ? (
        <div className="indet" role="progressbar" aria-label={t('accounts.hosts.arriving')} />
      ) : (
        <ErrorState
          title={t('accounts.hosts.failedTitle')}
          description={failure}
          action={<Button onClick={retry}>{t('accounts.hosts.retry')}</Button>}
        />
      )}
    </AuthCard>
  );
}
